// extracted by mini-css-extract-plugin
module.exports = {"root":"_3nQgX","title":"_2tRKw","description":"-fxG2","resetLink":"_3ZKvB"};